/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';
import _ from 'underscore';

import {TFIObject} from 'notebook/tfi/TFIConstants';
import BenchlingData, {TFIJson, TFI_MIME_TYPE} from 'util/drag-and-drop/BenchlingData';

interface Props {
  tfiObject: TFIObject;
  children: React.ReactNode;
}

class TFIDragTarget extends React.Component<Props> {
  dragStartHandler = (e: any): void => {
    // eslint-disable-next-line new-cap
    const bd = BenchlingData(e);
    e.dataTransfer.effectAllowed = 'all';
    e.dataTransfer.dropEffect = 'move';

    const tfiJSON: TFIJson = {
      benchlingDataType: TFI_MIME_TYPE,
      id: this.props.tfiObject.id,
      accountId: this.props.tfiObject.accountId,
      name: this.props.tfiObject.name,
      accountType: this.props.tfiObject.accountType,
    };
    bd.setData<typeof TFI_MIME_TYPE>(TFI_MIME_TYPE, tfiJSON);
  };

  override render(): JSX.Element {
    return (
      <div
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, _.omit(this.props, 'tfiObject'), {
          draggable: true,
          onDragStart: this.dragStartHandler,
        })}
      >
        {this.props.children}
      </div>
    );
  }
}

export default TFIDragTarget;
